import { createSlice } from '@reduxjs/toolkit'
import { IRedux } from '../types'

const initialState: IRedux['utm'] = {
  referal_url_id: '',
  is_session_created: false,
}

export const { actions: utmActions, reducer: utmReducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => {
      return initialState
    },
    setReferralID: (state, action) => {
      state.referal_url_id = action.payload
    },
    createSession: (state) => {
      state.is_session_created = true
    },
  },
})
